import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";

import { AWSAuthService } from "@intocare-medapp/aws/http";

@Injectable()
export class ConfirmPasswordGuard {
	private readonly authService = inject(AWSAuthService);
	private readonly router = inject(Router);

	canActivate() {
		return this.authService.getUser() ? true : this.router.createUrlTree(["select-organisation"]);
	}
}
